import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
	appCreateSponsor,
	appDeleteSponsor,
	appGetAllSponsor,
	appUpdateSponsor,
	uploadSponsorImage,
} from '../../store/sponsor'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Paginate from '../pagination/paginate'
import Select from 'react-select'
import ImageUpload from '../ImageUpload'
import swal from 'sweetalert'
import PostPreview from '../PostPreview/PostPreview'
import ExportButton from '../../common/ExportButton'
import { sponsorExportColumns } from '../../config/exportColumns/sponsorExportColumns'
import { appAllGetPaymentSettings } from '../../store/paymentsetting'

function Sponsor({
	sansthaDetails,
	hubDetails,
	users,
	hideSansthaField,
	isHubPage,
	sponsor,
	sponsorList,
	sponsorpage,
	setSponsorPage,
	sponsorpaginate,
}) {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const params = useParams()
	const { id } = useParams()
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const payment = useSelector(state => state.paymentSettingsReducer.payment)

	// const [page, setPage] = useState(params.page || 1);
	const [showSponsorModal, setShowSponsorModal] = useState(false)
	const [editSponsorMode, setEditSponsorMode] = useState(false)
	const [editSponsorId, setEditSponsorId] = useState(null)
	const [startDate, setStartDate] = useState(new Date())
	const [endDate, setEndDate] = useState(
		new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
	)
	const userData = JSON.parse(localStorage.getItem('user') || '{}')
	const hubId = userData.hub

	const sponsorValidationSchema = Yup.object({
		// name: Yup.string().required("Name is required"),
		// description: Yup.string().required("Description is required"),
		// hub: Yup.string().required("Hub is required"),
		// sanstha: Yup.string().required("Sanstha is required"),
		// image: Yup.string().required("Required"),
		user: Yup.string().required('User is required'),
		image: Yup.string()
			.required('Image is required')
			.test('is-valid-url', 'Invalid image', value => {
				return value && value !== '/img/default-placeholder.jpg'
			}),
	})

	useEffect(() => {
		dispatch(appAllGetPaymentSettings())
	}, [dispatch])

	const today = new Date()
	const todayStr = today.toISOString().split('T')[0]

	const nextYear = new Date()
	nextYear.setFullYear(nextYear.getFullYear() + 1)
	const nextYearStr = nextYear.toISOString().split('T')[0]

	const sponsorFormik = useFormik({
		initialValues: {
			// name: '',
			// description: '',
			sanstha: id,
			hub: hubId,
			image: '',
			user: '',
			startDate: todayStr,
			endDate: nextYearStr,
			sponsorDate: '',
			sponsorfee: '',
			note: '',
		},
		validationSchema: sponsorValidationSchema,
		onSubmit: values => {
			//	console.log(values)
			const temp_obj = {
				// name: values?.name,
				image: values?.image,
				hub: typeof values?.hub === 'object' ? values?.hub._id : values?.hub,
				user: values?.user,
				startDate: values.startDate,
				endDate: values.endDate,
				// description: values?.description,
				sponsorDate: values?.sponsorDate,
				sponsorfee: values?.sponsorfee,
				amount: Number(values?.sponsorfee || 0),
				note: values?.note,
				navigate: navigate,
			}

			if (!isHubPage) {
				temp_obj.sanstha =
					typeof values?.sanstha === 'object' ? values?.sanstha._id : values?.sanstha
			}
			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)
			filtered_obj.navigate = navigate
			// if (editSponsorMode && editSponsorId) {
			//   dispatch(appUpdateSponsor({ ...filtered_obj, id: editSponsorId }))
			//   .then(() => {
			//     dispatch(appGetAllSponsor({ page: 1, limit: 10, hub: hubDetails?._id , admin: true}));
			//     dispatch(appGetAllSponsor({ page: 1, limit: 10, sanstha: sansthaDetails?._id }));
			//   })
			// } else {
			//   dispatch(appCreateSponsor(filtered_obj))
			//   .then(() => {
			//     dispatch(appGetAllSponsor({ page: 1, limit: 10, hub: hubDetails?._id , admin: true}));
			//     dispatch(appGetAllSponsor({ page: 1, limit: 10, sanstha: sansthaDetails?._id }));
			//   })
			// }
			if (editSponsorMode && editSponsorId) {
				dispatch(appUpdateSponsor({ ...filtered_obj, id: editSponsorId })).then(() => {
					if (isHubPage && hubDetails?._id) {
						dispatch(
							appGetAllSponsor({
								page: 1,
								limit: 10,
								hub: hubDetails?._id,
								admin: true,
							}),
						)
					} else if (!isHubPage && sansthaDetails?._id) {
						dispatch(
							appGetAllSponsor({
								page: 1,
								limit: 10,
								sanstha: sansthaId || permissionOfSanstha,
							}),
						)
					}
				})
			} else {
				dispatch(appCreateSponsor(filtered_obj)).then(() => {
					if (isHubPage && hubDetails?._id) {
						dispatch(
							appGetAllSponsor({
								page: 1,
								limit: 10,
								hub: hubDetails?._id,
								admin: true,
							}),
						)
					} else if (!isHubPage && sansthaDetails?._id) {
						dispatch(
							appGetAllSponsor({
								page: 1,
								limit: 10,
								sanstha: sansthaId || permissionOfSanstha,
							}),
						)
					}
				})
			}

			setShowSponsorModal(false)
			setEditSponsorMode(false)
			setEditSponsorId(null)
			sponsorFormik.resetForm()
		},
	})

	const handleEditSponsor = sponsor => {
		//	console.log(sponsor, 'sponsor')
		setEditSponsorMode(true)
		setEditSponsorId(sponsor._id)
		setShowSponsorModal(true)
		sponsorFormik.setValues({
			// name: sponsor.name,
			// description: sponsor.description,
			hub: hubDetails?._id,
			sanstha: id,
			image: sponsor.image,
			user: sponsor.user._id,
			sponsorDate: sponsor.sponsorDate,
			sponsorfee: sponsor.sponsorfee,
			note: sponsor.note,
		})
		if (sponsor?.startDate) {
			const date = new Date(sponsor.startDate)
			setStartDate(date)
			sponsorFormik.setFieldValue('startDate', date.toISOString().split('T')[0])
		}
		if (sponsor?.endDate) {
			const date = new Date(sponsor.endDate)
			setEndDate(date)
			sponsorFormik.setFieldValue('endDate', date.toISOString().split('T')[0])
		}
	}

	const handleAddNewSponsor = () => {
		setEditSponsorMode(false)
		setEditSponsorId(null)

		const today = new Date()
		const todayStr = today.toISOString().split('T')[0]

		const nextYear = new Date()
		nextYear.setFullYear(nextYear.getFullYear() + 1)
		const nextYearStr = nextYear.toISOString().split('T')[0]

		sponsorFormik.setValues({
			// description: '',
			hub: hubDetails?._id,
			sanstha: id,
			image: '',
			user: '',
			sponsorDate: '',
			sponsorfee: '',
			note: '',
			startDate: todayStr,
			endDate: nextYearStr,
		})

		setShowSponsorModal(true)
	}
	const handleDeleteSponsor = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this sponsor?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteSponsor(id)).then(() => {
					dispatch(
						appGetAllSponsor({
							page: 1,
							limit: 10,
							hub: hubDetails?._id,
							admin: true,
						}),
					)
				})
			}
		})
	}

	const allCommunityFee = payment?.allcommunity || 0
	const communityFee = payment?.community?.price || 0
	const sansthaFee = payment?.sanstha?.price || 0

	useEffect(() => {
		let fee = 0

		// const hasSanstha = !!sponsorFormik.values.sanstha
		// const hasCommunity = !!sponsorFormik.values.hub

		if (isHubPage) {
			fee = communityFee
		} else {
			fee = sansthaFee
		}

		sponsorFormik.setFieldValue('sponsorfee', fee)
	}, [
		sponsorFormik.values.sanstha,
		sponsorFormik.values.hub,
		communityFee,
		sansthaFee,
		allCommunityFee,
	])

	return (
		<div>
			<div className="mb-3 mr-2 d-flex justify-content-between align-items-center">
				<h4 className="ml-2">Total Sponsors: {sponsorList?.length || 0}</h4>

				<div className="d-flex align-items-center">
					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllSponsor({
									...params,
									page: 1,
									limit: 100000,
									sanstha: sansthaId || permissionOfSanstha,
									loading: false,
								}),
							)
						}
						columns={sponsorExportColumns}
						fileName="Sponsors"
						sheetName="Sponsors"
						buttonText="Export Sponsors"
					/>

					<button className="btn btn-primary ml-2" onClick={handleAddNewSponsor}>
						<i className="far fa-plus"></i> Add New Sponsor
					</button>
				</div>
			</div>

			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead className="">
						<tr>
							<th>Sr. No.</th>
							<th>Sponsor</th>
							<th>User</th>
							<th>Duration</th>
							<th>Recived Amount (Rs)</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{sponsor?.length > 0 ? (
							sponsor.map((sponsor, index) => (
								<tr key={index}>
									<td>{index + 1}</td>
									<td>
										<PostPreview value={sponsor.image} />
										{sponsor?.name}{' '}
									</td>
									<td>
										{sponsor?.user?.firstName} {sponsor?.user?.lastName}
									</td>
									<td>
										{' '}
										{new Date(sponsor?.startDate).toLocaleDateString('en-US', {
											year: 'numeric',
											month: 'short',
											day: 'numeric',
										})}{' '}
										-{' '}
										{new Date(sponsor?.endDate).toLocaleDateString('en-US', {
											year: 'numeric',
											month: 'short',
											day: 'numeric',
										})}
									</td>
									<td>{sponsor?.amount || 0}</td>
									<td>
										<button
											className="btn btn-sm btn-primary mr-2"
											title="Edit"
											onClick={() => handleEditSponsor(sponsor)}
										>
											<i className="far fa-edit"></i>
										</button>
										<button
											className="btn btn-sm btn-danger"
											title="Delete"
											onClick={() => handleDeleteSponsor(sponsor?._id)}
										>
											<i className="far fa-trash-alt"></i>
										</button>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="7" className="text-center">
									No sponsors data available
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
			{sponsorpaginate && (
				<Paginate paginate={sponsorpaginate} page={sponsorpage} setPage={setSponsorPage} />
			)}

			{showSponsorModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">
									{editSponsorMode ? 'Edit Sponsor' : 'Create New Sponsor'}
								</h5>
								<button
									type="button"
									className="close"
									onClick={() => {
										setShowSponsorModal(false)
										setEditSponsorMode(false)
										setEditSponsorId(null)
										sponsorFormik.resetForm()
									}}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<form onSubmit={sponsorFormik.handleSubmit}>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Select Users</label>
												<Select
													options={
														Array.isArray(users)
															? users.map(user => ({
																	value: user._id,
																	label: `${[user.firstName, user.lastName]
																		.filter(Boolean)
																		.join(' ')} (${user.mobile || ''})`,
															  }))
															: []
													}
													onBlur={() => sponsorFormik.setFieldTouched('user', true)}
													onChange={option => {
														sponsorFormik.setFieldValue('user', option?.value)

														const selectedUser = Array.isArray(users)
															? users.find(u => u._id === option?.value)
															: null
														if (selectedUser) {
															sponsorFormik.setFieldValue('name', selectedUser.firstName)
														}
													}}
													value={
														Array.isArray(users)
															? users
																	.filter(user => user._id === sponsorFormik.values.user)
																	.map(user => ({
																		value: user._id,
																		label: `${[user.firstName, user.lastName]
																			.filter(Boolean)
																			.join(' ')} (${user.mobile || ''})`,
																	}))[0] || null
															: null
													}
													placeholder="Select User..."
												/>

												{sponsorFormik.touched.user && sponsorFormik.errors.user ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.user}</div>
												) : null}
											</div>
										</div>

										<div className="col-md-6">
											<ImageUpload
												uploadFunction={uploadSponsorImage}
												fieldName="image"
												value={sponsorFormik.values.image}
												onChange={value => sponsorFormik.setFieldValue('image', value.url)}
												error={
													sponsorFormik.touched.image && sponsorFormik.errors.image
														? sponsorFormik.errors.image
														: null
												}
											/>
										</div>

										{/* <div className="col-md-6">
											<div className="form-group">
												<label>Name *</label>
												<input
													className="form-control"
													name="name"
													type="text"
													onChange={sponsorFormik.handleChange}
													onBlur={sponsorFormik.handleBlur}
													value={sponsorFormik.values.name}
												/>
												{sponsorFormik.touched.name && sponsorFormik.errors.name ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.name}</div>
												) : null}
											</div>
										</div> */}
									</div>

									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Date of offline payment received</label>

												<input
													type="date"
													className="form-control"
													value={sponsorFormik.values.sponsorDate || ''}
													onChange={e => {
														const rawValue = e.target.value
														if (!rawValue) {
															sponsorFormik.setFieldValue('sponsorDate', '')
															// setStartDate(null);
															return
														}

														const dateObj = new Date(rawValue)
														if (isNaN(dateObj.getTime())) return

														sponsorFormik.setFieldValue('sponsorDate', rawValue)
													}}
												/>
												{sponsorFormik.touched.sponsorDate && sponsorFormik.errors.sponsorDate ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.sponsorDate}</div>
												) : null}
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>Sponsor Fee </label>
												<input
													type="number"
													className="form-control"
													name="sponsorfee"
													value={sponsorFormik.values.sponsorfee}
													// onChange={sponsorFormik.handleChange}
													// onBlur={sponsorFormik.handleBlur}
													readOnly
												/>
											</div>
										</div>
									</div>

									<div className="row" style={{ padding: '0 0 15px 0' }}>
										<div className="col-md-6">
											<div className="form-group">
												<label>Start Date </label>
												<input
													type="date"
													className="form-control"
													// value={
													//   sponsorFormik.values.startDate
													//     ? sponsorFormik.values.startDate
													//     : startDate ? startDate.toISOString().split("T")[0] : ""
													// }
													value={sponsorFormik.values.startDate || ''}
													onChange={e => {
														if (!e.target.value) {
															sponsorFormik.setFieldValue('startDate', '')
															sponsorFormik.setFieldValue('endDate', '')
															setStartDate(null)
															setEndDate(null)
															return
														}
														const dateValue = new Date(e.target.value)
														if (isNaN(dateValue.getTime())) {
															return
														}
														setStartDate(dateValue)
														let dateOnly = dateValue.toISOString().split('T')[0]
														sponsorFormik.setFieldValue('startDate', dateOnly)

														const nextYear = new Date(dateValue)
														nextYear.setFullYear(nextYear.getFullYear() + 1)
														setEndDate(nextYear)
														sponsorFormik.setFieldValue(
															'endDate',
															nextYear.toISOString().split('T')[0],
														)
													}}
												/>
												{/* {sponsorFormik.touched.startDate && sponsorFormik.errors.startDate ? (
                      <div style={{ color: "red" }}>
                        {sponsorFormik.errors.startDate}
                      </div>
                    ) : null} */}
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>End Date </label>
												<input
													type="date"
													className="form-control"
													// value={
													//   sponsorFormik.values.endDate
													//     ? sponsorFormik.values.endDate
													//     : endDate ? endDate.toISOString().split("T")[0] : ""
													// }
													value={sponsorFormik.values.endDate || ''}
													readOnly
												/>
												{/* {sponsorFormik.touched.endDate && sponsorFormik.errors.endDate ? (
                      <div style={{ color: "red" }}>
                        {sponsorFormik.errors.endDate}
                      </div>
                    ) : null} */}
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label>Notes (payment details and received by)</label>
												<textarea
													className="form-control"
													name="note"
													onChange={sponsorFormik.handleChange}
													onBlur={sponsorFormik.handleBlur}
													value={sponsorFormik.values.note}
													rows="3"
												/>
											</div>
											{/* <div className="form-group">
												<label>Description *</label>
												<textarea
													className="form-control"
													name="description"
													onChange={sponsorFormik.handleChange}
													onBlur={sponsorFormik.handleBlur}
													value={sponsorFormik.values.description}
													rows="3"
												/>
												{sponsorFormik.touched.description && sponsorFormik.errors.description ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.description}</div>
												) : null}
											</div> */}
										</div>
									</div>
									<div className="modal-footer">
										<button className="btn btn-labeled btn-success" type="submit">
											<span className="btn-label">
												<i className="fa fa-check"></i>
											</span>
											{editSponsorMode ? 'Update' : 'Create'}
										</button>
										<button
											className="btn btn-labeled btn-secondary ml-2"
											type="button"
											onClick={() => {
												setShowSponsorModal(false)
												setEditSponsorMode(false)
												setEditSponsorId(null)
												sponsorFormik.resetForm()
											}}
										>
											<span className="btn-label">
												<i className="fa fa-times"></i>
											</span>
											Cancel
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
export default Sponsor
